'use client'

import React from 'react'
import { useUserContext } from 'shared/context/UserContext'
import { useInfiniteFetchMessages } from '@o2x/data-store'
import ChatCountDot, {
  ChatCountDotStyleProps,
} from 'shared/components/CountDot/CountDot'
const AllUnreadChatMessagesCountDot = ({
  color = 'primary',
  className,
  ...props
}: ChatCountDotStyleProps) => {
  const { userId, authToken } = useUserContext()

  const { data, isLoading, isError } = useInfiniteFetchMessages(
    userId!,
    authToken
  )

  if (isLoading || isError || !data) {
    console.log('Loading or error', { isLoading, isError })
    return null
  }

  const allMessages = data.pages.flatMap((page) => page.entities.items)

  const unreadCount = allMessages.filter(
    (msg: any) =>
      msg.senderId !== userId && !(msg.readById ?? []).includes(userId)
  ).length

  if (unreadCount === 0) return null

  return (
    <ChatCountDot
      count={unreadCount}
      aria-label={`${unreadCount} unread messages`}
      {...props}
    />
  )
}

export default AllUnreadChatMessagesCountDot
